import instance from '@/utils/api'
import store from '@/store'
import router from '@/router'

/**
 * 用户登录
 * @param {*} data 
 * @returns 
 */
export function login(data) {
    return instance({
        url: "/user/login",
        method: 'post',
        data: data
    }).then(res => {
        if (res.success) {
            store.commit('SET_TOKEN', res.data);
            // 在登录成功的处理逻辑中进行页面跳转
            router.push('/admin'); // 跳转到名为 'dashboard' 的路由
        }
    }).catch(error => {
        console.log(error);
    })
}
/**
 * 注册
 * @param {*} data 
 * @returns 
 */
export function register(data) {
    return instance({
        url: "/user/register",
        method: 'post',
        data: data
    }).then(res => {
        if (res.success) {
            store.commit('SET_TOKEN', res.data);
            // 在登录成功的处理逻辑中进行页面跳转
            router.push('/admin'); // 跳转到名为 'dashboard' 的路由
        }
    }).catch(error => {
        console.log(error);
    })
}
/**
 * 获取验证码
 * @param {*} data 
 * @returns 
 */
export function verificationCode(email) {
    return instance({
        url: "/user/verificationCode",
        method: 'post',
        params: {  // 改用 params 传递，后端才能用 @RequestParam 接收
            email: email
        }
    }).then(res => {
        if (res.success) {
            console.log(res);
        }
    }).catch(error => {
        console.log(error);
    })
}
/**
 * 用户登出
 * @param {*} data 
 * @returns 
 */
export function logout() {
    return instance({
        url: "/user/logout",
        method: 'post',
    }).then(res => {
        console.log(res);
        store.commit('LOGIN_OUT');
        // 在登录成功的处理逻辑中进行页面跳转
        router.push('/'); // 跳转到名为 'dashboard' 的路由
    }).catch(error => {
        console.log(error);
    })
}

/**
 * 查询当前登录人信息
 * @returns 
 */
export function queryLoginUserInfo() {
    return instance({
        url: "/user/selectLoginUserInfo",
        method: 'get'
    }).then(res => {
        if (res.success) {
            store.commit('SET_USER_INFO', res.data);
            return res;
        }else{
            logout();
        }
    }).catch(error => {
        console.log(error);
    })
}

export function selectUserInfoOne(user) {
    // 如果 user 为空，将其设置为一个空的 JSON 对象
    if (!user) {
        user = {};
    }
    // 将数据对象序列化为 JSON 字符串
    const jsonData = JSON.stringify(user);
    return instance({
        url: "/user/selectUserInfoOne",
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: jsonData
    }).then(res => {
        if (res.success) {
            store.commit('SET_USER_INFO', res.data);
            return res;
        }
    }).catch(error => {
        console.log(error);
    })
}